import type { BaseClient } from "./client";
import type { APIResponse, ClusterDetail } from "./types";
import type { FeatureGatesResponse } from "./features";

const BASE = "/api/v1/operator";

/** One entry of OpenDeskCluster.spec.cluster.registry.mirrors. */
export interface RegistryMirror {
  source: string;
  mirror: string;
  credentialRef?: { name: string };
  enterpriseOnly?: boolean;
}

export interface RegistryMirrorsResponse {
  mirrors: RegistryMirror[];
}

/**
 * Cluster API: reads the OpenDeskCluster CR status.
 */
export class ClusterApi {
  constructor(private readonly client: BaseClient) {}

  /** Get cluster overview (phase, version, components, compliance, drift). */
  async getCluster(): Promise<APIResponse<ClusterDetail>> {
    return this.client.get<ClusterDetail>(`${BASE}/cluster`);
  }

  /** Set feature gates on the cluster (platform-admin). */
  async patchFeatureGates(
    clusterName: string,
    gates: Record<string, boolean>,
  ): Promise<APIResponse<FeatureGatesResponse>> {
    return this.client.patch<FeatureGatesResponse>(`${BASE}/clusters/${encodeURIComponent(clusterName)}/feature-gates`, { gates });
  }

  /** Read the registry mirror list (platform-admin). */
  async getRegistryMirrors(clusterName: string): Promise<APIResponse<RegistryMirrorsResponse>> {
    return this.client.get<RegistryMirrorsResponse>(`${BASE}/clusters/${encodeURIComponent(clusterName)}/registry-mirrors`);
  }

  /** Replace the registry mirror list (platform-admin). */
  async putRegistryMirrors(clusterName: string, mirrors: RegistryMirror[]): Promise<APIResponse<RegistryMirrorsResponse>> {
    return this.client.put<RegistryMirrorsResponse>(`${BASE}/clusters/${encodeURIComponent(clusterName)}/registry-mirrors`, { mirrors });
  }
}
